<h2 mat-dialog-title>
  @if (isEditMode) {
    <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
    Rediger prisregulering
  }
  @if (!isEditMode) {
    <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
    Opret prisregulering
  }
</h2>
<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>

<mat-dialog-content>
  <form [formGroup]="form">
    <div class="form-row">
      <mat-form-field title="Navn">
        <mat-label>Navn</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>
    </div>

    <div class="form-row">
      <label class="attachment-label">Tilknytning</label>
      <mat-radio-group formControlName="scopeType" class="attachment-radio-group" aria-label="Tilknytning">
        <mat-radio-button [value]="PriceRegulationScopeType.Global">Global</mat-radio-button>
        <mat-radio-button [value]="PriceRegulationScopeType.Organization">Organisation</mat-radio-button>
      </mat-radio-group>
    </div>

    @if (scopeType() === PriceRegulationScopeType.Organization) {
      <div class="form-row">
        <adm-org-typeahead
          [initialId]="form.controls.organization.value?.id"
          [disabled]="isEditMode"
          (itemSelected)="selectOrganization($event)"
          (clearTypeAhead)="resetOrganization()" />
      </div>
    }

    <div class="form-row">
      <mat-form-field title="Type">
        <mat-label>Type</mat-label>
        <mat-select formControlName="type" okCustomDropDownArrowDirective>
          <mat-option [value]="PriceRegulationType.Discount">
            {{ PriceRegulationType.Discount | translatePriceRegulationType }}
          </mat-option>
          <mat-option [value]="PriceRegulationType.SupplementOverride">
            {{ PriceRegulationType.SupplementOverride | translatePriceRegulationType }}
          </mat-option>
        </mat-select>
        <mat-icon matSuffix></mat-icon>
      </mat-form-field>
    </div>

    @if (selectedType() === PriceRegulationType.Discount) {
      <div class="form-row">
        <adm-price-ex-incl-vat
          headline="Rabat"
          formControlNameExclVat="discountAmountInKrWithoutVat"
          [initialExclVat]="form.controls.discountAmountInKrWithoutVat.value"
          formControlNameInclVat="discountAmountInKrWithoutVat" />
        @if (form.controls.discountAmountInKrWithoutVat.touched && form.controls.discountAmountInKrWithoutVat.hasError('required')) {
          <mat-error class="standalone-error">Indtast venligst et tillæg </mat-error>
        }
        @if (
          form.controls.discountAmountInKrWithoutVat.touched &&
          (form.controls.discountAmountInKrWithoutVat.hasError('min') || form.controls.discountAmountInKrWithoutVat.hasError('max'))
        ) {
          <mat-error class="standalone-error">Værdi skal være 0-100 </mat-error>
        }
      </div>
    }

    @if (selectedType() === PriceRegulationType.SupplementOverride) {
      <div class="form-row supplement-row">
        <mat-slide-toggle formControlName="overrideOkSupplement"> Overskriv OK-tillæg </mat-slide-toggle>

        @if (form.controls.overrideOkSupplement.value) {
          <adm-price-ex-incl-vat
            headline="OK-tillæg"
            formControlNameExclVat="okSupplementOverrideInKrWithoutVat"
            [initialExclVat]="form.controls.okSupplementOverrideInKrWithoutVat.value"
            formControlNameInclVat="okSupplementOverrideInKrWithoutVat" />
        }

        @if (
          form.controls.okSupplementOverrideInKrWithoutVat.touched && form.controls.okSupplementOverrideInKrWithoutVat.hasError('required')
        ) {
          <mat-error class="standalone-error">Indtast venligst et tillæg </mat-error>
        }
        @if (
          form.controls.okSupplementOverrideInKrWithoutVat.touched &&
          (form.controls.okSupplementOverrideInKrWithoutVat.hasError('min') ||
            form.controls.okSupplementOverrideInKrWithoutVat.hasError('max'))
        ) {
          <mat-error class="standalone-error">Værdi skal være 0-100 </mat-error>
        }
      </div>

      <div class="form-row supplement-row">
        <mat-slide-toggle formControlName="overrideOrganizationSupplement"> Overskriv kundetillæg </mat-slide-toggle>

        @if (form.controls.overrideOrganizationSupplement.value) {
          <adm-price-ex-incl-vat
            headline="Kundetillæg"
            formControlNameExclVat="organizationSupplementOverrideInKrWithoutVat"
            [initialExclVat]="form.controls.organizationSupplementOverrideInKrWithoutVat.value"
            formControlNameInclVat="organizationSupplementOverrideInKrWithoutVat" />
        }

        @if (
          form.controls.organizationSupplementOverrideInKrWithoutVat.touched &&
          form.controls.organizationSupplementOverrideInKrWithoutVat.hasError('required')
        ) {
          <mat-error class="standalone-error">Indtast venligst et tillæg </mat-error>
        }
        @if (
          form.controls.organizationSupplementOverrideInKrWithoutVat.touched &&
          (form.controls.organizationSupplementOverrideInKrWithoutVat.hasError('min') ||
            form.controls.organizationSupplementOverrideInKrWithoutVat.hasError('max'))
        ) {
          <mat-error class="standalone-error">Værdi skal være 0-100 </mat-error>
        }
      </div>

      @if (form.hasError('supplementOverrideRequired') && form.touched) {
        <mat-error class="standalone-error"> Vælg mindst ét tillæg, der skal overskrives </mat-error>
      }
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button type="button" (click)="cancel()">Luk</button>
  <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="form.invalid || !form.dirty">
    {{ isEditMode ? 'Gem' : 'Opret' }}
  </button>
</mat-dialog-actions>
